module.exports = __webpack_public_path__ + "./yachu_dcbca5e17cad2a1e6b12823f8c9bffd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/yachu.png
// module id = 473
// module chunks = 0